import { ImageLoaderProps } from 'next/image';

export function parseImageUrl(url: string) {
  return url.replaceAll(
    process.env.NEXT_PUBLIC_IMAGES_WORDPRESS_BASE_URL ?? '',
    process.env.NEXT_PUBLIC_IMAGES_CLOUDINARY_BASE_URL ?? '',
  );
}

export function cloudinaryLoader({ src, width, quality }: ImageLoaderProps) {
  return `${process.env.NEXT_PUBLIC_IMAGES_CLOUDINARY_BASE_URL ?? ''}${src}?tx=w_${width},q_${quality ?? 'auto'}`;
}

export function getMimeTypeImage(url: string) {
  if (url.endsWith('png')) return 'image/png';
  if (url.endsWith('jpg') || url.endsWith('jpeg')) return 'image/jpeg';
  return null;
}

export default {};
